// @flow
import React, { type Node, Fragment } from 'react';
import { ThemeProvider as LibThemeProvider } from 'styled-components';

import { type Theme, themeOverride } from '@rover/kibble/styles';

export type Props = {|
  theme: Theme,
  children: Node,
|};

const ThemeProvider = ({ theme, children }: Props) => (
  <LibThemeProvider theme={theme}>
    <Fragment>{children}</Fragment>
  </LibThemeProvider>
);

ThemeProvider.defaultProps = {
  theme: themeOverride,
};

export default ThemeProvider;



// WEBPACK FOOTER //
// ../react-lib/src/components/utils/ThemeProvider/ThemeProvider.jsx